<template>
  <div>
    <div :class="$style.article_div">
      {{message}}
    </div>
    <!-- <span v-if="{{errors.length > 0}}" >Error</span> -->
  </div>
</template>

<script>
// import signalR from 'signal-exit'
export default {
  name: 'About',
  data () {
    return {
      message: 'TODO: About',
      article: {title: {rendered: ''}, content: {rendered: ''}, date: '1999/12/31T00:00:00'}, // dummy
      errors: []
    }
  }
  // created: function () {
  //   console.error('UserId')
  //   const connection = new signalR.HubConnectionBuilder()
  //     .withUrl('https://vtubers-api.azurewebsites.net/ShowHub')
  //     .configureLogging(signalR.LogLevel.Information)
  //     .build()
  //   connection.start().catch(err => console.error(err.toString()))
  //   connection.invoke('JoinShow', 'room001').catch(err => console.error(err.toString()))
  //   connection.on('ReceiveMessage', (UserId, Name, ProfilePhotoUrl) => {
  //     console.error(UserId)
  //   })
  // }
}
</script>

<style module>
  .article_div {
    padding: 10px 10px 10px 10px
  }
  .article_body {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/About.vue